import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { linkedBankAccountRepository } from '../data-access/repositories/LinkedBankAccountRepository'

const base = ['linked-bank-account']

export const linkedBankAccountQueryConfig = {
  getLinkedBankAccounts: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () => linkedBankAccountRepository.getLinkedBankAccounts(params),
  }),
}
